import React from 'react';

import { AlertDismissable } from './AlertDismissable';

export const AlarmAlert = () => {
  return (
    <AlertDismissable dismissable={false} preference={'showAlarmAlert'}>
      <p>
        Unfortunately, Talk Sync is no longer being maintained. The apps are no longer available in the app stores, and
        accounts can no longer be renewed.
      </p>
      <p>The website will continue to function through September, 2026 to allow people to download their recordings.</p>
      <p>Thank you for all of your support over the years!</p>
      <p>-- The Talk Sync team</p>
    </AlertDismissable>
  );
};
